import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PieChart from 'react-svg-piechart';

import '../styles/default-pie-chart.css';

class DefaultPieChart extends Component {
  renderChart(title, data) {
    const { t } = this.context;

    if (!this.areAllValuesZero(data)) {
      return (
        <div className="text-center">
          <h3>{t(title)}</h3>
          <PieChart data={data} expandOnHover />
        </div>
      );
    } else return null;
  }

  renderLegend(showLegend, data) {
    const { t } = this.context;

    if (showLegend && !this.areAllValuesZero(data)) {
      return (
        <div className="pie-legend text-center p-l-20">
          {data.map((item, index) => (
            <div className="display-flex-vertical m-b-5" key={index}>
              <div className="pie-legend__box" style={{ background: item.color }} />
              <span className="pie-legend__tex">
                {t(item.label)}: {item.value}
              </span>
            </div>
          ))}
        </div>
      );
    } else return null;
  }

  areAllValuesZero(data) {
    return data && data.length > 0 ? data.every(item => item.value === 0) : true;
  }

  render() {
    const { title, data, customClass, showLegend } = this.props;

    return (
      <div className={`pie-chart-container ${customClass || ''}`}>
        {this.renderChart(title, data)}
        {this.renderLegend(showLegend, data)}
      </div>
    );
  }
}

DefaultPieChart.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default DefaultPieChart;



// WEBPACK FOOTER //
// ./src/app/shared/default-pie-chart/components/default-pie-chart.js